import React from "react";

import {MuiIcon, MuiIconExternalProps} from './MuiIcon';

export const LeftPanelOpen = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon{...props}
                    ref={ref}
            >{'\uf716'}</MuiIcon>
        );
    }
)
